/*
 * ---------------------------------------------------------------------
 * import modules
 * ---------------------------------------------------------------------
 */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    IconButton,
    Tooltip,
    ListItem,
    ListItemIcon,
    ListItemText,
} from "@material-ui/core";

import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

import {
    t,
    Translate,
} from "src/shared_modules/i18n";

import {
    hideContent
} from "src/shared_modules/veu-visitors-core/actions/content";

import {
    hidePageGlobal,
} from "src/shared_modules/veu-visitors-core/actions/pages";

import {
    openContentOrPageClickHandler
} from "src/shared_modules/veu-visitors-core/components/content-view/utils";

import {
    SYSTEM_CONTENT
} from "src/constants";

/*
 * ---------------------------------------------------------------------
 * class HelpButton
 * ---------------------------------------------------------------------
 */
class HelpButton extends React.Component {

    componentDidMount() {
        this.clickHelp = this.clickHelp.bind(this);
    }

    clickHelp() {
        let isOpen = false;
        if( SYSTEM_CONTENT.HELP.type === "static" ) {
            isOpen = (this.props.content.isOpen && this.props.content.url === SYSTEM_CONTENT.HELP.url);
        } else if( SYSTEM_CONTENT.HELP.type === "global" ) {
            isOpen = (this.props.isGlobalOpen && this.props.pageGlobal.identifier === SYSTEM_CONTENT.HELP.id);
        }

        if( isOpen )
        {
            if( SYSTEM_CONTENT.HELP.type === "static" ) {
                this.props.hideContent();
            } else if( SYSTEM_CONTENT.HELP.type === "global" ) {
                this.props.hidePageGlobal();
            }
        } else {
            openContentOrPageClickHandler(SYSTEM_CONTENT.HELP);
        }

        if( this.props.onClick )
            this.props.onClick();
    }

    render() {
        let colorhelp = "primary";
        if( this.props.content.isOpen && this.props.content.url === "help.html"  )
            colorhelp = "secondary";

        return (<React.Fragment>
                    {!this.props.mobile && <Tooltip title={t("main-nav.help")}>
                        <IconButton aria-label="help" onClick={ ()=> { this.clickHelp(); } }>
                            <HelpOutlineIcon color={colorhelp} />
                        </IconButton>
                    </Tooltip> }
                    { this.props.mobile &&  <ListItem button onClick={ ()=> { this.clickHelp(); } } >
                        <ListItemIcon><HelpOutlineIcon /></ListItemIcon>
                        <ListItemText primary={<Translate>main-nav.help</Translate>} />
                    </ListItem> }
            </React.Fragment>);
    }
}
/*
 * ---------------------------------------------------------------------
 * HelpButton prop Types
 * ---------------------------------------------------------------------
 */
HelpButton.propTypes = {
    currentLang : PropTypes.string,
};
/*
 * ---------------------------------------------------------------------
 * HelpButton Redux Container
 * ---------------------------------------------------------------------
 */
const mapStateToProps = ( state, ownProps ) => {
    return {
        currentLang : state.system.currentLang,
        content : state.content,
        isGlobalOpen: state.pages.isGlobalOpen,
        pageGlobal: state.pages.pageGlobal,
    };
};

const mapDispatchToProps = {
    hideContent,
    hidePageGlobal,
};

/*
 * ---------------------------------------------------------------------
 * Export the redux container
 * ---------------------------------------------------------------------
 */
export default connect(
        mapStateToProps,
        mapDispatchToProps
    )(HelpButton);
